module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"BugReport":"Anomalies","PullRequestReport":"Pull requests","Title":"Kezber Reports","VelocityReport":"Vélocité","AvailabilityReport":"Disponibilité","PreSaleAnalysisActivitiesReport":"Analyse prévente","WorkItemsWordExportReport":"Work Items Export"}}')
  delete Component.options._Ctor
}
